// source: tableau/metrics/models/date_window.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return window;
}.call(null));

var tableau_metrics_models_data_values_pb = require('../../../tableau/metrics/models/data_values_pb.js');
goog.object.extend(proto, tableau_metrics_models_data_values_pb);
var tableau_metrics_models_duration_pb = require('../../../tableau/metrics/models/duration_pb.js');
goog.object.extend(proto, tableau_metrics_models_duration_pb);
goog.exportSymbol('proto.tableau.metrics.models.p4.AllTimeWindowType', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.DateWindow', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.DateWindow.TypeCase', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.DefinedStartWindowType', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.LatestDataWindowType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.DateWindow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.tableau.metrics.models.p4.DateWindow.oneofGroups_);
};
goog.inherits(proto.tableau.metrics.models.p4.DateWindow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.DateWindow.displayName = 'proto.tableau.metrics.models.p4.DateWindow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tableau.metrics.models.p4.DefinedStartWindowType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.DefinedStartWindowType.displayName = 'proto.tableau.metrics.models.p4.DefinedStartWindowType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.LatestDataWindowType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tableau.metrics.models.p4.LatestDataWindowType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.LatestDataWindowType.displayName = 'proto.tableau.metrics.models.p4.LatestDataWindowType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.AllTimeWindowType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tableau.metrics.models.p4.AllTimeWindowType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.AllTimeWindowType.displayName = 'proto.tableau.metrics.models.p4.AllTimeWindowType';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.tableau.metrics.models.p4.DateWindow.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.tableau.metrics.models.p4.DateWindow.TypeCase = {
  TYPE_NOT_SET: 0,
  TYPE_DEFINED_START_WINDOW: 1,
  TYPE_LATEST_DATA_WINDOW: 2,
  TYPE_ALL_TIME_WINDOW: 3
};

/**
 * @return {proto.tableau.metrics.models.p4.DateWindow.TypeCase}
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.getTypeCase = function() {
  return /** @type {proto.tableau.metrics.models.p4.DateWindow.TypeCase} */(jspb.Message.computeOneofCase(this, proto.tableau.metrics.models.p4.DateWindow.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.DateWindow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.DateWindow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DateWindow.toObject = function(includeInstance, msg) {
  var f, obj = {
    typeDefinedStartWindow: (f = msg.getTypeDefinedStartWindow()) && proto.tableau.metrics.models.p4.DefinedStartWindowType.toObject(includeInstance, f),
    typeLatestDataWindow: (f = msg.getTypeLatestDataWindow()) && proto.tableau.metrics.models.p4.LatestDataWindowType.toObject(includeInstance, f),
    typeAllTimeWindow: (f = msg.getTypeAllTimeWindow()) && proto.tableau.metrics.models.p4.AllTimeWindowType.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.DateWindow}
 */
proto.tableau.metrics.models.p4.DateWindow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.DateWindow;
  return proto.tableau.metrics.models.p4.DateWindow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.DateWindow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.DateWindow}
 */
proto.tableau.metrics.models.p4.DateWindow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tableau.metrics.models.p4.DefinedStartWindowType;
      reader.readMessage(value,proto.tableau.metrics.models.p4.DefinedStartWindowType.deserializeBinaryFromReader);
      msg.setTypeDefinedStartWindow(value);
      break;
    case 2:
      var value = new proto.tableau.metrics.models.p4.LatestDataWindowType;
      reader.readMessage(value,proto.tableau.metrics.models.p4.LatestDataWindowType.deserializeBinaryFromReader);
      msg.setTypeLatestDataWindow(value);
      break;
    case 3:
      var value = new proto.tableau.metrics.models.p4.AllTimeWindowType;
      reader.readMessage(value,proto.tableau.metrics.models.p4.AllTimeWindowType.deserializeBinaryFromReader);
      msg.setTypeAllTimeWindow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.DateWindow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.DateWindow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DateWindow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTypeDefinedStartWindow();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.tableau.metrics.models.p4.DefinedStartWindowType.serializeBinaryToWriter
    );
  }
  f = message.getTypeLatestDataWindow();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tableau.metrics.models.p4.LatestDataWindowType.serializeBinaryToWriter
    );
  }
  f = message.getTypeAllTimeWindow();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.tableau.metrics.models.p4.AllTimeWindowType.serializeBinaryToWriter
    );
  }
};


/**
 * optional DefinedStartWindowType type_defined_start_window = 1;
 * @return {?proto.tableau.metrics.models.p4.DefinedStartWindowType}
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.getTypeDefinedStartWindow = function() {
  return /** @type{?proto.tableau.metrics.models.p4.DefinedStartWindowType} */ (
    jspb.Message.getWrapperField(this, proto.tableau.metrics.models.p4.DefinedStartWindowType, 1));
};


/**
 * @param {?proto.tableau.metrics.models.p4.DefinedStartWindowType|undefined} value
 * @return {!proto.tableau.metrics.models.p4.DateWindow} returns this
*/
proto.tableau.metrics.models.p4.DateWindow.prototype.setTypeDefinedStartWindow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.tableau.metrics.models.p4.DateWindow.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.DateWindow} returns this
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.clearTypeDefinedStartWindow = function() {
  return this.setTypeDefinedStartWindow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.hasTypeDefinedStartWindow = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LatestDataWindowType type_latest_data_window = 2;
 * @return {?proto.tableau.metrics.models.p4.LatestDataWindowType}
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.getTypeLatestDataWindow = function() {
  return /** @type{?proto.tableau.metrics.models.p4.LatestDataWindowType} */ (
    jspb.Message.getWrapperField(this, proto.tableau.metrics.models.p4.LatestDataWindowType, 2));
};


/**
 * @param {?proto.tableau.metrics.models.p4.LatestDataWindowType|undefined} value
 * @return {!proto.tableau.metrics.models.p4.DateWindow} returns this
*/
proto.tableau.metrics.models.p4.DateWindow.prototype.setTypeLatestDataWindow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.tableau.metrics.models.p4.DateWindow.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.DateWindow} returns this
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.clearTypeLatestDataWindow = function() {
  return this.setTypeLatestDataWindow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.hasTypeLatestDataWindow = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AllTimeWindowType type_all_time_window = 3;
 * @return {?proto.tableau.metrics.models.p4.AllTimeWindowType}
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.getTypeAllTimeWindow = function() {
  return /** @type{?proto.tableau.metrics.models.p4.AllTimeWindowType} */ (
    jspb.Message.getWrapperField(this, proto.tableau.metrics.models.p4.AllTimeWindowType, 3));
};


/**
 * @param {?proto.tableau.metrics.models.p4.AllTimeWindowType|undefined} value
 * @return {!proto.tableau.metrics.models.p4.DateWindow} returns this
*/
proto.tableau.metrics.models.p4.DateWindow.prototype.setTypeAllTimeWindow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.tableau.metrics.models.p4.DateWindow.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.DateWindow} returns this
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.clearTypeAllTimeWindow = function() {
  return this.setTypeAllTimeWindow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DateWindow.prototype.hasTypeAllTimeWindow = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.DefinedStartWindowType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.DefinedStartWindowType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && tableau_metrics_models_data_values_pb.DateTime.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.DefinedStartWindowType}
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.DefinedStartWindowType;
  return proto.tableau.metrics.models.p4.DefinedStartWindowType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.DefinedStartWindowType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.DefinedStartWindowType}
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new tableau_metrics_models_data_values_pb.DateTime;
      reader.readMessage(value,tableau_metrics_models_data_values_pb.DateTime.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.DefinedStartWindowType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.DefinedStartWindowType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      tableau_metrics_models_data_values_pb.DateTime.serializeBinaryToWriter
    );
  }
};


/**
 * optional DateTime start_date = 1;
 * @return {?proto.tableau.metrics.models.p4.DateTime}
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType.prototype.getStartDate = function() {
  return /** @type{?proto.tableau.metrics.models.p4.DateTime} */ (
    jspb.Message.getWrapperField(this, tableau_metrics_models_data_values_pb.DateTime, 1));
};


/**
 * @param {?proto.tableau.metrics.models.p4.DateTime|undefined} value
 * @return {!proto.tableau.metrics.models.p4.DefinedStartWindowType} returns this
*/
proto.tableau.metrics.models.p4.DefinedStartWindowType.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.DefinedStartWindowType} returns this
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DefinedStartWindowType.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.LatestDataWindowType.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.LatestDataWindowType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.LatestDataWindowType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.LatestDataWindowType.toObject = function(includeInstance, msg) {
  var f, obj = {
    duration: (f = msg.getDuration()) && tableau_metrics_models_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.LatestDataWindowType}
 */
proto.tableau.metrics.models.p4.LatestDataWindowType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.LatestDataWindowType;
  return proto.tableau.metrics.models.p4.LatestDataWindowType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.LatestDataWindowType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.LatestDataWindowType}
 */
proto.tableau.metrics.models.p4.LatestDataWindowType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new tableau_metrics_models_duration_pb.Duration;
      reader.readMessage(value,tableau_metrics_models_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.LatestDataWindowType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.LatestDataWindowType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.LatestDataWindowType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.LatestDataWindowType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      tableau_metrics_models_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional Duration duration = 1;
 * @return {?proto.tableau.metrics.models.p4.Duration}
 */
proto.tableau.metrics.models.p4.LatestDataWindowType.prototype.getDuration = function() {
  return /** @type{?proto.tableau.metrics.models.p4.Duration} */ (
    jspb.Message.getWrapperField(this, tableau_metrics_models_duration_pb.Duration, 1));
};


/**
 * @param {?proto.tableau.metrics.models.p4.Duration|undefined} value
 * @return {!proto.tableau.metrics.models.p4.LatestDataWindowType} returns this
*/
proto.tableau.metrics.models.p4.LatestDataWindowType.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.LatestDataWindowType} returns this
 */
proto.tableau.metrics.models.p4.LatestDataWindowType.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.LatestDataWindowType.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.AllTimeWindowType.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.AllTimeWindowType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.AllTimeWindowType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.AllTimeWindowType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.AllTimeWindowType}
 */
proto.tableau.metrics.models.p4.AllTimeWindowType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.AllTimeWindowType;
  return proto.tableau.metrics.models.p4.AllTimeWindowType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.AllTimeWindowType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.AllTimeWindowType}
 */
proto.tableau.metrics.models.p4.AllTimeWindowType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.AllTimeWindowType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.AllTimeWindowType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.AllTimeWindowType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.AllTimeWindowType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.tableau.metrics.models.p4);
